import { RefObject, useEffect } from 'react';

type Params = {
  callback: () => void;
  ref: RefObject<HTMLSpanElement>;
  isOpen?: boolean;
};

export function useClickOutside({ callback, ref, isOpen }: Params) {
  useEffect(
    function onClickOutside() {
      const el = ref.current;
      if (!el || !isOpen) return;

      function handleClickOutside(event: MouseEvent) {
        if (!el?.contains(event.target as Node)) {
          callback();
        }
      }

      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    },
    [callback, isOpen, ref],
  );
}
